import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  [
    "flex min-w-[2.375rem] cursor-pointer items-center justify-center !rounded-xl px-4 py-2 font-semibold capitalize transition-shadow duration-100 ease-in-out focus:!outline-none active:!outline-none",
    "ring-secondary-500 transition-opacity duration-200 focus:ring-2 focus:ring-offset-2 active:ring-2 active:ring-offset-1 dark:ring-offset-gray-950",
  ],
  {
    variants: {
      size: {
        small: "h-[2.375rem] !text-sm",
        medium: "h-11",
        icon: "size-fit min-h-0 min-w-0 p-2",
      },
      intent: {
        default: [
          "border border-gray-300",
          "bg-gray-0 border-gray-300 !text-gray-950 hover:!bg-gray-50",
          "dark:!text-gray-0 dark:border-gray-700 dark:bg-gray-950 dark:hover:!bg-gray-900",
        ],
        transparent: [
          "bg-transparent !outline-none",
          "!text-gray-500 hover:!text-gray-700",
          "dark:!text-gray-400 dark:hover:!text-gray-300",
        ],
        primary: [
          "bg-primary-600 !text-gray-25 ring-primary-500 hover:bg-primary-300",
        ],
        warning:
          "bg-warning-600 !text-gray-0 ring-warning-500 hover:bg-warning-500",
        danger: "bg-error-600 !text-gray-0 ring-error-500 hover:bg-error-500",
        secondary:
          "bg-secondary-500 !text-gray-0 hover:bg-secondary-600 hover:!text-gray-0",
        "secondary-light":
          "!text-secondary-700 hover:!text-secondary-700 bg-secondary-25 hover:bg-secondary-25",
        // bg-gray-0 here is a template workaround
        "secondary-outline":
          "border-secondary-500 bg-gray-0 !text-secondary-500 border hover:bg-gray-50 dark:bg-transparent",
        "error-outline":
          "border-error-600 bg-gray-0 !text-error-600 ring-error-600 border hover:bg-gray-50 dark:bg-transparent",
        "secondary-light-outline":
          "!text-secondary-700 bg-secondary-25 hover:bg-secondary-25 border-secondary-700 border",
        link: "!text-primary-600 ring-primary-500 hover:!text-primary-300 overflow-hidden bg-[#0000] p-0 hover:underline dark:!text-[#8DA0FF] dark:ring-[#8DA0FF]",
        "link-warning":
          "!text-warning-600 ring-warning-500 hover:!text-warning-500 bg-[#0000] p-0 hover:underline",
        "link-error":
          "!text-error-600 ring-error-500 hover:!text-error-500 bg-[#0000] p-0 hover:underline",
        "link-secondary":
          "!text-secondary-600 ring-secondary-500 hover:!text-secondary-500 bg-[#0000] p-0 hover:underline",
        gradient:
          "from-secondary-900 to-secondary-600 !rounded-full bg-gradient-to-br text-white",
      },
    },
    defaultVariants: {
      size: "medium",
      intent: "default",
    },
  },
);

export const disabledButtonVariants = cva(
  [
    "cursor-not-allowed opacity-50 !ring-0 !ring-offset-0 focus:!ring-0 focus:!ring-offset-0 active:!ring-0 active:!ring-offset-0",
  ],
  {
    variants: {
      intent: {
        default: "hover:bg-gray-25",
        primary: "hover:bg-primary-600",
        warning: "hover:bg-warning-600",
        danger: "hover:bg-error-600",
        secondary: "hover:bg-secondary-500",
        "secondary-light": "hover:bg-secondary-25",
        "secondary-outline": "hover:bg-gray-0",
        "error-outline": "hover:bg-gray-0",
        "secondary-light-outline": "hover:bg-gray-0",
        transparent: "hover:bg-transparent",
        link: "!text-primary-200 hover:!text-primary-200 hover:bg-transparent hover:no-underline",
        "link-warning":
          "!text-warning-200 hover:!text-warning-200 hover:bg-transparent hover:no-underline",
        "link-error":
          "!text-error-200 hover:!text-error-200 hover:bg-transparent hover:no-underline",
        "link-secondary":
          "!text-secondary-200 hover:!text-secondary-200 hover:bg-transparent hover:no-underline",
        gradient: "hover:from-primary-300 hover:to-secondary-600",
      },
    },
    defaultVariants: {
      intent: "default",
    },
  },
);

export const buttonSpinnerVariants = cva("", {
  variants: {
    intent: {
      default: "dark:!fill-gray-0 !fill-gray-500",
      transparent: "!fill-gray-500 dark:!fill-gray-400",
      primary: "!fill-gray-25",
      warning: "!fill-gray-0",
      danger: "!fill-gray-0",
      secondary: "!fill-gray-0 hover:!fill-gray-0",
      "secondary-light": "!fill-secondary-700 hover:!fill-secondary-700",
      // bg-gray-0 here is a template workaround
      "secondary-outline": "!fill-secondary-500",
      "error-outline": "!fill-error-600",
      "secondary-light-outline": "!fill-secondary-700",
      link: "!fill-primary-600 hover:!fill-primary-300 dark:!fill-[#8DA0FF]",
      "link-warning": "!fill-warning-600 hover:!fill-warning-500",
      "link-error": "!fill-error-600 hover:!fill-error-500",
      "link-secondary": "!fill-secondary-600 hover:!fill-secondary-500",
      gradient: "!fill-gray-0 hover:!fill-gray-0",
    },
  },
  defaultVariants: {
    intent: "default",
  },
});
